/* Puppygirlparadise — header search suggestions and catalogue filtering.
   No dependencies, same house style as global.js. */
(function () {
  'use strict';

  /* ------------------------------------------------------ search suggest */

  document.querySelectorAll('[data-search]').forEach(function (root) {
    var input = root.querySelector('[data-search-input]');
    var panel = root.querySelector('[data-search-panel]');
    if (!input || !panel) return;

    var url = root.getAttribute('data-suggest-url') || '/search/suggest.json';
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var timer = null;
    var lastQuery = '';

    function money(amount) {
      var value = parseFloat(amount);
      if (isNaN(value)) return '';
      var parts = value.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
    }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      // panel emptied; aria-live on the panel announces the change
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render(products, query) {
      if (!products.length) {
        panel.innerHTML = '<p class="search__empty">Nothing matched &ldquo;' + escapeHtml(query) + '&rdquo;. Try &ldquo;ears&rdquo; or &ldquo;tail&rdquo;.</p>';
        panel.hidden = false;
        return;
      }

      var html = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" width="46" height="46" loading="lazy">'
          : '<img src="" alt="" width="46" height="46">';
        return (
          '<a class="search__row" href="' + escapeHtml(p.url) + '">' +
            img +
            '<span>' +
              '<span class="search__row-title">' + escapeHtml(p.title) + '</span><br>' +
              '<span class="search__row-price">' + money(p.price) + '</span>' +
            '</span>' +
          '</a>'
        );
      }).join('');

      html += '<a class="search__all" href="/search?q=' + encodeURIComponent(query) + '">See everything for &ldquo;' + escapeHtml(query) + '&rdquo;</a>';

      panel.innerHTML = html;
      panel.hidden = false;
    }

    function fetchSuggestions(query) {
      var endpoint = url +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(endpoint, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || input.value.trim() !== query) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, query);
        })
        .catch(function () { close(); });
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (timer) clearTimeout(timer);

      if (query.length < 2) {
        lastQuery = '';
        close();
        return;
      }
      if (query === lastQuery) return;
      lastQuery = query;

      timer = setTimeout(function () { fetchSuggestions(query); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) close();
    });

    document.addEventListener('focusin', function (e) {
      if (!root.contains(e.target)) close();
    });
  });

  /* --------------------------------------------------- catalogue filters */

  document.querySelectorAll('[data-catalogue]').forEach(function (bar) {
    var scope = bar.parentElement || document;
    var grid = scope.querySelector('[data-catalogue-grid]');
    var countEl = bar.querySelector('[data-catalogue-count]');
    var emptyEl = scope.querySelector('[data-catalogue-empty]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.cat-item'));
    var state = { animal: 'all', kind: 'all', spice: 'all' };

    function apply() {
      var shown = 0;

      items.forEach(function (item) {
        var animals = (item.getAttribute('data-animal') || '').split(/\s+/);
        var kind = item.getAttribute('data-kind') || '';
        var spice = item.getAttribute('data-spice') || 'cute';
        var ok =
          (state.animal === 'all' || animals.indexOf(state.animal) !== -1) &&
          (state.kind === 'all' || kind === state.kind) &&
          (state.spice === 'all' || spice === state.spice);

        item.hidden = !ok;
        if (ok) shown++;
      });

      if (countEl) {
        countEl.textContent = shown + (shown === 1 ? ' thing' : ' things');
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;
      grid.hidden = shown === 0;
    }

    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('.chip');
      if (!chip) return;

      var group = chip.getAttribute('data-filter');
      state[group] = chip.getAttribute('data-value');

      bar.querySelectorAll('.chip[data-filter="' + group + '"]').forEach(function (c) {
        c.setAttribute('aria-pressed', String(c === chip));
      });

      apply();
    });

    if (emptyEl) {
      var reset = emptyEl.querySelector('[data-catalogue-reset]');
      if (reset) {
        reset.addEventListener('click', function () {
          state.animal = 'all';
          state.kind = 'all';
          state.spice = 'all';
          bar.querySelectorAll('.chip').forEach(function (c) {
            c.setAttribute('aria-pressed', String(c.getAttribute('data-value') === 'all'));
          });
          apply();
        });
      }
    }
  });
})();
